<template>
  <div>
    <v-autocomplete
      item-value="id"
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :label="label"
      :chips="chips"
      :deletableChips="deletableChips"
      :outlined="outlined"
      :dense="dense"
      :rules="rules"
      :multiple="multiple"
      :auto-select-first="autoSelectFirst"
      hide-details
      hide-selected
    >
      <template v-slot:selection="data">
        <v-chip
          class="mt-1 mb-1"
          v-if="chips"
          :small="smallChips"
          :close="deletableChips"
          close-icon="mdi-close"
          @click:close="removeItem(data.item)"
        >
          {{ data.item.name }}
        </v-chip>
        <span v-else>
          {{ data.item.name }}
        </span>
      </template>
      <template v-slot:item="data">
        <span>
          {{ data.item.name }}
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import SETTINGS from '@/services/settings'

export default {
  props: {
    chips: {
      type: Boolean,
      default: false,
    },
    smallChips: {
      type: Boolean,
      default: false,
    },
    deletableChips: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    autoSelectFirst: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String | Number | Array,
      default: null,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
    },
  },
  data() {
    return {
      model: this.multiple ? [this.value] : `${this.value}`,
      search: null,
      isLoading: false,
      items: [],
      timeout: null,
    }
  },
  methods: {
    removeItem(item) {
      this.model = this.model.filter(i => i !== item.id)
    },
    selectBank(bank) {
      if (this.multiple) this.model = [...this.model, bank.id]
      else this.model = bank.id

      this.$emit('input', this.modal)
    },
    async s(val) {
      try {
        if (this.isLoading) return
        this.isLoading = true

        const { banks } = await SETTINGS.banks.getAll()
        this.items = banks
      } catch (e) {
        this.$toast.fire({
          icon: 'error',
          title: e.message,
        })
      } finally {
        this.isLoading = false
      }
    },
  },
  watch: {
    value: {
      async handler(value) {
        this.model = value
        if (value) await this.s(value)
      },
      immediate: true,
    },
    model(value) {
      if (!value) this.$emit('input', null)
      this.$emit('input', value)
      this.search = null
    },
    async search(val) {
      if (!val || val.length < 4) return
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.s(val)
      }, 500)
    },
  },
  async mounted() {
    await this.s()
  },
}
</script>

<style></style>
